import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import isArray from 'lodash/isArray';
import { Goal } from './types';

const showGoalsWithThisStatus = ['planned', 'accepted', 'in-progress', 'sustaining', 'achieved'];

export const goalsSelector = (state: RootState) => state.goals.data;
export const goalsLoadingState = (state: RootState) => state.goals.isFetching;
export const goalsErrorSelector = (state: RootState) => state.goals.error;
export const goalsRequestStateSelector = (state: RootState) => state.goals.requestState;

const filterByStatus = (goal: Goal) => showGoalsWithThisStatus.includes(goal.status);

export const anyGoals = createSelector([goalsSelector], data => data.length > 0);

export const sortByStartDateDesc = (sourceArray: Goal[]) => {
  if (!sourceArray || !isArray(sourceArray)) return [];

  return sourceArray.sort((firstEl, secondEl) => {
    const firstDate = new Date(firstEl.startDate).getTime();
    const secondDate = new Date(secondEl.startDate).getTime();
    return secondDate - firstDate;
  });
};

export const filteredGoalsSelector = createSelector([goalsSelector], data =>
  sortByStartDateDesc(data?.filter(filterByStatus))
);
